import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=2000b35c&scoped=true&"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarMenuItem.vue?vue&type=style&index=0&id=2000b35c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2000b35c",
  null
  
)

export default component.exports